import { useEffect } from 'react';
import './partners.scss';
import { applySeo, siteUrl } from '../../utils/seo';
import NorthStarLogo from '../../images/north-star-scientific-logo-horizontal.svg';
import SpectrumLogo from '../../images/spectrum-optics-logo.webp';
import ToupTekLogo from '../../images/touptek-astro-logo.webp';

const partners = [
    {
        name: 'Spectrum Optics',
        relationship: 'Brand Ambassador',
        url: 'https://spectrumoi.com/DavidJoyce.php',
        linkLabel: 'View my ambassador page',
        logo: SpectrumLogo,
        description: [
            'I’m proud to be a brand ambassador for Spectrum Optics, a maker of telescopes, mounts, and astronomy accessories. Visit their site to explore the full product line and view my ambassador page.'
        ]
    },
    {
        name: 'NorthStar Scientific',
        relationship: 'Affiliate',
        url: 'https://www.nstarscientific.com/ASTRO_DAVIDO',
        linkLabel: 'Shop with my affiliate link',
        logo: NorthStarLogo,
        isAffiliate: true,
        description: [
            'NorthStar Scientific makes a build-your-own Newtonian reflector telescope from 3D-printed parts. It’s compact and travel-friendly, packing down small enough to bring along for camping or trips to darker skies.',
            'Use my affiliate link below to shop and support the site at no extra cost to you.'
        ]
    },
    {
        name: 'ToupTek Astro',
        relationship: 'Affiliate',
        url: 'https://www.touptekastro.com/astro_davido',
        linkLabel: 'Shop with my affiliate link',
        logo: ToupTekLogo,
        isAffiliate: true,
        description: [
            'ToupTek Astro builds astronomy imaging cameras and accessories, from cooled deep-sky CMOS cameras to planetary cameras and filter wheels.',
            'Use my affiliate link below to shop and support the site at no extra cost to you.'
        ]
    }
];

const Partners = () => {
    useEffect(() => {
        applySeo({
            title: 'Partners | David Joyce Astrophotography',
            description: 'Brands David Joyce (AstroDavido) works with, including a Spectrum Optics ambassadorship and NorthStar Scientific and ToupTek Astro affiliate partnerships.',
            canonicalPath: '/partners/',
            ogImage: `${siteUrl}/logo192.png`,
            structuredData: {
                '@context': 'https://schema.org',
                '@type': 'CollectionPage',
                name: 'Partners',
                description: 'Brands and companies David Joyce (AstroDavido) partners with in astrophotography.',
                url: `${siteUrl}/partners/`
            }
        });
    }, []);

    return (
        <div className='partners-page'>
            <div className='partners-hero'>
                <h1>Partners</h1>
                <p>
                    A few brands I work with in astrophotography, from an ambassadorship to gear I use and recommend.
                </p>
            </div>

            <div className='partners-list'>
                {partners.map((partner) => (
                    <article className='partner-card' key={partner.name}>
                        <div className='partner-card-header'>
                            <h2 className={partner.logo ? 'partner-logo-heading' : undefined}>
                                {partner.logo ? (
                                    <img src={partner.logo} alt={partner.name} className='partner-logo' />
                                ) : (
                                    partner.name
                                )}
                            </h2>
                            <span className='partner-relationship-badge'>{partner.relationship}</span>
                        </div>

                        {partner.description.map((paragraph, index) => (
                            <p className='partner-description' key={index}>{paragraph}</p>
                        ))}

                        <a className='partner-link' href={partner.url} target='_blank' rel='noreferrer sponsored'>
                            {partner.linkLabel}
                        </a>
                    </article>
                ))}
            </div>

            <p className='partners-disclosure'>
                Disclosure: Some links on this page are affiliate links. If you make a purchase through them,
                I may earn a small commission at no additional cost to you.
            </p>
        </div>
    );
};

export default Partners;
